const validator = {
  getMessage(field, args) {
    return "Este campo é obrigatório"
  },
  validate(value, args) {
    return (value != 0 && value != '0' && value != null)
  }
}

export default validator



// WEBPACK FOOTER //
// ./src/validators/zero-validator.js